export const planetChartData = {
  type: 'doughnut',
  data: {
    labels: ['Porcentaje de cumplimiento', "Porcentaje de no cumplimiento"],
    datasets: [

      { // one line graph
        label: "Tiempo promedio",
        data: [15, 5],
        backgroundColor: [
          'rgba(0, 27, 122, 0.5)', // Blue
          'rgba(122, 0, 0, 0.5)',
          'rgba(54,73,93,.5)',
          'rgba(54,73,93,.5)',
          'rgba(54,73,93,.5)',
          'rgba(54,73,93,.5)',
          'rgba(54,73,93,.5)',
          'rgba(54,73,93,.5)'
        ],
        borderColor: [
          '#36495d',
          '#36495d',
          '#36495d',
          '#36495d',
          '#36495d',
          '#36495d',
          '#36495d',
          '#36495d',
          '#36495d',
        ],
        borderWidth: 3
      }

    ]
  },
  options: {
    title: {
      display: true,
      text: "Cumplimiento de SLA replicas convencional"
    },

    //  responsive: true,
    // maintainAspectRatio: false,
    lineTension: 1,
    scales: {
      yAxes: [{
        ticks: {
          min: 0,
          beginAtZero: true,
          stacked: true,
          callback: function () {

            return '';
          }
        },
        scaleLabel: {
          display: true,
          fontSize: 12,

        },
        gridLines: {
          display: false,
        },
      }],
      xAxes: [{
        stacked: true,
        gridLines: {
          display: false,
        },
        ticks: {
          // Include a dollar sign in the ticks
          callback: function () {

            return '';
          }
        }
      }]
    },
    legend: {
      display: true,

    },
    tooltips: {
      callbacks: {
        label: function (tooltipItem, data) {
          var dataset = data.datasets[tooltipItem.datasetIndex];
          var currentValue = dataset.data[tooltipItem.index];
          return data.labels[tooltipItem.index] + ": " + currentValue + "%";
        }
      }
    }
  }
}

export default planetChartData;